var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTechSeminarsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:teach-poll"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 17C21.1 17 22 16.1 22 15V4C22 2.9 21.1 2 20 2H10.7853C10.1948 2 9.80132 2.62456 9.91803 3.20344C10.0047 3.63352 10.3557 4 10.7944 4H20V15H11V17M14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9V21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21V17C7 16.4477 6.55228 16 6 16C5.44772 16 5 16.4477 5 17V21C5 21.5523 4.55228 22 4 22C3.44772 22 3 21.5523 3 21V14H2.5C1.94772 14 1.5 13.5523 1.5 13V9C1.5 7.9 2.4 7 3.5 7H14ZM8 4C8 5.1 7.1 6 6 6C4.9 6 4 5.1 4 4C4 2.9 4.9 2 6 2C7.1 2 8 2.9 8 4ZM17 7C17 6.44772 17.4477 6 18 6C18.5523 6 19 6.44772 19 7V13C19 13.5523 18.5523 14 18 14C17.4477 14 17 13.5523 17 13V7ZM14 11C14 10.4477 14.4477 10 15 10C15.5523 10 16 10.4477 16 11V13C16 13.5523 15.5523 14 15 14C14.4477 14 14 13.5523 14 13V11ZM11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13V11Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechSeminarsIcon);
export default __webpack_public_path__ + "static/media/techSeminarsIcon.63e9ee7fc9af197801249f3221fb8d07.svg";
export { ForwardRef as ReactComponent };